export default __webpack_public_path__ + "static/media/gil_kerbs.4d659a01.jpeg";